// src/components/HomeBanner.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const HomeBanner = () => {
  const [banners, setBanners] = useState([]);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  // Fetch banners on component mount
  useEffect(() => {
    const fetchBanners = async () => {
      try {        
        const response = await axios.get('/admin/public/banners');
        
        const activeBanners = response.data.filter(banner => 
          banner.isActive && 
          (banner.audience === 'all' || banner.audience === 'guest')
        );
        
        setBanners(activeBanners);
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch banners:', error);
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  // Banner rotation effect
  useEffect(() => {
    if (banners.length > 1) {
      const interval = setInterval(() => {
        setCurrentBannerIndex((prevIndex) => 
          (prevIndex + 1) % banners.length
        );
      }, 5000); // Rotate every 5 seconds

      return () => clearInterval(interval);
    }
  }, [banners.length]);

  // Handle banner click for tracking
  const handleBannerClick = async (bannerId) => {
    try {
      await axios.post('/admin/public/banner-click', { bannerId });
    } catch (error) {
      console.error('Failed to track banner click:', error);
    }
  };

  if (loading || banners.length === 0) {
    return null; // Don't show anything while loading or if no banners exist
  }

  const currentBanner = banners[currentBannerIndex];

  return (
    <div className="home-banner-container mt-5 mb-4">
      <div 
        className="alert alert-primary py-3 px-4 text-center"
        style={{ 
          cursor: 'pointer',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          border: 'none',
          background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
          color: 'white'
        }}
        onClick={() => handleBannerClick(currentBanner._id)}
        title="Click for more information"
      >
        {currentBanner.imageDataUrl ? (
          <>
            <img
              src={currentBanner.imageDataUrl}
              alt="Promotional Banner"
              className="mb-3"
              style={{ 
                width: '100%', 
                maxWidth: '600px',
                height: 'auto', 
                maxHeight: '200px',
                objectFit: 'contain',
                display: 'block', 
                margin: '0 auto',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
              }}
            />
            {(currentBanner.title || currentBanner.message) && (
              <div className="banner-text">
                {currentBanner.title && (
                  <h4 className="mb-2 fw-bold text-white">{currentBanner.title}</h4>
                )}
                {currentBanner.message && (
                  <p className="mb-0 text-white-50">{currentBanner.message}</p>
                )}
              </div>
            )}
          </>
        ) : (
          <div className="banner-text-only">
            {currentBanner.title && (
              <h4 className="mb-2 fw-bold text-white">{currentBanner.title}</h4>
            )}
            {currentBanner.message && (
              <p className="mb-0 lead text-white">{currentBanner.message}</p>
            )}
          </div>
        )}

        {/* Banner rotation indicators */}
        {banners.length > 1 && (
          <div className="d-flex justify-content-center mt-3">
            {banners.map((_, index) => (
              <div
                key={index}
                className={`mx-1 rounded-circle ${
                  index === currentBannerIndex ? 'bg-white' : 'bg-white-50'
                }`}
                style={{ 
                  width: '10px', 
                  height: '10px',
                  opacity: index === currentBannerIndex ? 1 : 0.5,
                  transition: 'opacity 0.3s ease'
                }}
              />
            ))}
          </div>
        )}

        {/* Banner info for multiple banners */}
        {banners.length > 1 && (
          <div className="mt-2">
            <small className="text-white-50">
              Banner {currentBannerIndex + 1} of {banners.length}
            </small>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeBanner;
